import { Badge } from "~/components/design-system/components"

/** Marks the collection (or target) a collection is linked to as its comparable. */
export const LinkedBadge = ({ className }: { className?: string }) => (
  <Badge variant="violet" size="xs" className={className}>
    Linked
  </Badge>
)
